import React from "react";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const AccountEmpRangeFilter = ({
  value,
  onChange,
  options,
  classes,
  paddingAvailable = false,
}) => {
  //   const classes = useStyles();

  return (
    <Grid item xs={12} container component={Paper} spacing={2}>
      <Grid
        item
        xs={12}
        sm={12}
        style={paddingAvailable ? {} : { paddingTop: 0 }}
      >
        <FormControl fullWidth className={classes.formControl}>
          <InputLabel
            className={classes.filterLabel}
            style={{ color: !value.includes("All") ? "#4472c4" : "#000" }}
            id="select-region-label"
          >
            Account Emp. Range :
          </InputLabel>
          <Select
          id="filter_Acct_Emp_Range"
            data-test="Acct_Emp_Range"
            value={value}
            onChange={onChange}
            name="Acct_Emp_Range"
            multiple
          >
            <MenuItem value={"All"}>All</MenuItem>
            {options &&
              options.map((item) => (
                <MenuItem key={item.Acct_Emp_Range} value={item.Acct_Emp_Range}>
                  {item.Acct_Emp_Range}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default AccountEmpRangeFilter;
